<nz-drawer
  wilsonDrawerSettingsManager
  [drawerId]="drawerId"
  [nzExtra]="extraTemplate"
  [nzVisible]="(drawerIsOpen$ | async) || false"
  [nzTitle]="'audit_trail.drawer.header' | translate"
  [nzMask]="true"
  [nzMaskStyle]="{ backgroundColor: 'transparent' }"
  [nzClosable]="true"
  (nzOnClose)="closeDrawer()"
>
  <ng-container *nzDrawerContent>
    <wilson-nz-drawer-content [drawerId]="drawerId">
      @if (auditTrail$ | async; as auditTrail) {
        <nz-timeline>
          @for (auditTrailItem of auditTrail; track auditTrailItem) {
            @if (auditTrailItem.types[0] !== 'unknown') {
              <nz-timeline-item nzColor="blue">
                <div class="audit-timeline-item">
                  <!-- Single action: actor + full sentence -->
                  @if (auditTrailItem.types.length === 1) {
                    @switch (auditTrailItem.types[0]) {
                      @case ('created') {
                        <p>
                          {{
                            $safeNavigationMigration(
                              auditTrailItem?.historyDelta?.updatedById
                            )
                              | userName
                              | async
                          }}
                          {{ 'audit_trail.shift.created' | translate }}
                        </p>
                      }
                      @case ('assigned') {
                        <p>
                          {{
                            $safeNavigationMigration(
                              auditTrailItem?.historyDelta?.updatedById
                            )
                              | userName
                              | async
                          }}
                          {{ 'audit_trail.shift.assigned' | translate }}
                          <strong>{{
                            $safeNavigationMigration(
                              auditTrailItem?.historyDelta?.userId
                            )
                              | userName
                              | async
                          }}</strong>
                        </p>
                      }
                      @case ('released') {
                        <p>
                          {{
                            $safeNavigationMigration(
                              auditTrailItem?.historyDelta?.updatedById
                            )
                              | userName
                              | async
                          }}
                          {{ 'audit_trail.shift.released' | translate }}
                        </p>
                      }
                      @case ('unreleased') {
                        <p>
                          {{
                            $safeNavigationMigration(
                              auditTrailItem?.historyDelta?.updatedById
                            )
                              | userName
                              | async
                          }}
                          {{ 'audit_trail.shift.unreleased' | translate }}
                        </p>
                      }
                      @case ('unassigned') {
                        <p>
                          {{
                            $safeNavigationMigration(
                              auditTrailItem?.historyDelta?.updatedById
                            )
                              | userName
                              | async
                          }}
                          {{ 'audit_trail.shift.unassigned' | translate }}
                          <strong>{{
                            auditTrailItem
                              | auditTrailPreviousAssignedUser
                              | userName
                              | async
                          }}</strong>
                        </p>
                      }
                      @case ('userAcceptedShift') {
                        <p>
                          {{
                            $safeNavigationMigration(
                              auditTrailItem?.historyDelta?.updatedById
                            )
                              | userName
                              | async
                          }}
                          {{
                            'audit_trail.shift.userAcceptedShift' | translate
                          }}
                        </p>
                      }
                      @case ('userDeclinedShift') {
                        <p>
                          {{
                            $safeNavigationMigration(
                              auditTrailItem?.historyDelta?.updatedById
                            )
                              | userName
                              | async
                          }}
                          @if (auditTrailItem.historyDelta.declineReason) {
                            {{
                              'audit_trail.shift.userDeclinedShiftReason'
                                | translate
                            }}
                            <strong>{{
                              auditTrailItem.historyDelta.declineReason
                            }}</strong>
                          } @else {
                            {{
                              'audit_trail.shift.userDeclinedShift' | translate
                            }}
                          }
                        </p>
                      }
                      @case ('ongoing') {
                        <p>
                          @if (currentShiftAssignedUserId) {
                            {{ currentShiftAssignedUserId | userName | async }}
                            {{ 'audit_trail.shift.ongoing' | translate }}
                          } @else {
                            {{ 'audit_trail.shift.ongoingNoUser' | translate }}
                          }
                        </p>
                      }
                      @case ('completed') {
                        <p>
                          @if (currentShiftAssignedUserId) {
                            {{ currentShiftAssignedUserId | userName | async }}
                            {{ 'audit_trail.shift.completed' | translate }}
                          } @else {
                            {{
                              'audit_trail.shift.completedNoUser' | translate
                            }}
                          }
                        </p>
                      }
                      @case ('submitted') {
                        <p>
                          {{
                            $safeNavigationMigration(
                              auditTrailItem?.historyDelta?.updatedById
                            )
                              | userName
                              | async
                          }}
                          {{ 'audit_trail.shift.submitted' | translate }}
                        </p>
                      }
                      @case ('acceptedAZM') {
                        <p>
                          {{
                            $safeNavigationMigration(
                              auditTrailItem?.historyDelta?.updatedById
                            )
                              | userName
                              | async
                          }}
                          {{ 'audit_trail.shift.acceptedAZM' | translate }}
                        </p>
                      }
                      @case ('reopened') {
                        <p>
                          {{
                            $safeNavigationMigration(
                              auditTrailItem?.historyDelta?.updatedById
                            )
                              | userName
                              | async
                          }}
                          {{ 'audit_trail.shift.reopened' | translate }}
                        </p>
                      }
                      @case ('acceptedPayroll') {
                        <p>
                          {{
                            $safeNavigationMigration(
                              auditTrailItem?.historyDelta?.updatedById
                            )
                              | userName
                              | async
                          }}
                          {{ 'audit_trail.shift.acceptedPayroll' | translate }}
                        </p>
                      }
                      @case ('changedDate') {
                        <p>
                          {{
                            $safeNavigationMigration(
                              auditTrailItem?.historyDelta?.updatedById
                            )
                              | userName
                              | async
                          }}
                          {{
                            'audit_trail.shift.changedDate.start' | translate
                          }}
                          <strong>{{
                            auditTrailItem | auditTrailPreviousStartDate
                          }}</strong>
                          {{
                            'audit_trail.shift.changedDate.center' | translate
                          }}
                          <strong>{{
                            auditTrailItem.historyDelta.startDate
                              | localizedDateFormat
                          }}</strong>
                        </p>
                      }
                      @case ('changedName') {
                        <p>
                          {{
                            $safeNavigationMigration(
                              auditTrailItem?.historyDelta?.updatedById
                            )
                              | userName
                              | async
                          }}
                          {{
                            'audit_trail.shift.changedName.start' | translate
                          }}
                          <strong>{{
                            auditTrailItem | auditTrailPreviousShiftName
                          }}</strong>
                          {{
                            'audit_trail.shift.changedName.center' | translate
                          }}
                          <strong>
                            {{ auditTrailItem.historyDelta.name }}
                          </strong>
                        </p>
                      }
                    }
                  } @else {
                    <!-- Multiple actions: actor once, then a list of actions -->
                    <p class="audit-timeline-item__actor">
                      {{
                        $safeNavigationMigration(
                          auditTrailItem?.historyDelta?.updatedById
                        )
                          | userName
                          | async
                      }}
                    </p>
                    <ul class="audit-timeline-item__action-list">
                      @for (
                        auditTrailType of auditTrailItem.types;
                        track auditTrailType
                      ) {
                        @if (auditTrailType !== 'unknown') {
                          <li>
                            @switch (auditTrailType) {
                              @case ('created') {
                                <span>{{
                                  'audit_trail.shift.created' | translate
                                }}</span>
                              }
                              @case ('assigned') {
                                <span>
                                  {{ 'audit_trail.shift.assigned' | translate }}
                                  <strong>{{
                                    $safeNavigationMigration(
                                      auditTrailItem?.historyDelta?.userId
                                    )
                                      | userName
                                      | async
                                  }}</strong>
                                </span>
                              }
                              @case ('released') {
                                <span>{{
                                  'audit_trail.shift.released' | translate
                                }}</span>
                              }
                              @case ('unreleased') {
                                <span>
                                  @if (
                                    auditTrailItem.types.includes(
                                      'userDeclinedShift'
                                    )
                                  ) {
                                    {{
                                      'audit_trail.shift.unreleasedAutomatically'
                                        | translate
                                    }}
                                  } @else {
                                    {{
                                      'audit_trail.shift.unreleased' | translate
                                    }}
                                  }
                                </span>
                              }
                              @case ('unassigned') {
                                <span>
                                  {{
                                    'audit_trail.shift.unassigned' | translate
                                  }}
                                  <strong>{{
                                    auditTrailItem
                                      | auditTrailPreviousAssignedUser
                                      | userName
                                      | async
                                  }}</strong>
                                </span>
                              }
                              @case ('userAcceptedShift') {
                                <span>{{
                                  'audit_trail.shift.userAcceptedShift'
                                    | translate
                                }}</span>
                              }
                              @case ('userDeclinedShift') {
                                <span>
                                  @if (
                                    auditTrailItem.historyDelta.declineReason
                                  ) {
                                    {{
                                      'audit_trail.shift.userDeclinedShiftReason'
                                        | translate
                                    }}
                                    <strong>{{
                                      auditTrailItem.historyDelta.declineReason
                                    }}</strong>
                                  } @else {
                                    {{
                                      'audit_trail.shift.userDeclinedShift'
                                        | translate
                                    }}
                                  }
                                </span>
                              }
                              @case ('ongoing') {
                                <span>
                                  @if (currentShiftAssignedUserId) {
                                    {{
                                      currentShiftAssignedUserId
                                        | userName
                                        | async
                                    }}
                                    {{
                                      'audit_trail.shift.ongoing' | translate
                                    }}
                                  } @else {
                                    {{
                                      'audit_trail.shift.ongoingNoUser'
                                        | translate
                                    }}
                                  }
                                </span>
                              }
                              @case ('completed') {
                                <span>
                                  @if (currentShiftAssignedUserId) {
                                    {{
                                      currentShiftAssignedUserId
                                        | userName
                                        | async
                                    }}
                                    {{
                                      'audit_trail.shift.completed' | translate
                                    }}
                                  } @else {
                                    {{
                                      'audit_trail.shift.completedNoUser'
                                        | translate
                                    }}
                                  }
                                </span>
                              }
                              @case ('submitted') {
                                <span>{{
                                  'audit_trail.shift.submitted' | translate
                                }}</span>
                              }
                              @case ('acceptedAZM') {
                                <span>{{
                                  'audit_trail.shift.acceptedAZM' | translate
                                }}</span>
                              }
                              @case ('reopened') {
                                <span>{{
                                  'audit_trail.shift.reopened' | translate
                                }}</span>
                              }
                              @case ('acceptedPayroll') {
                                <span>{{
                                  'audit_trail.shift.acceptedPayroll'
                                    | translate
                                }}</span>
                              }
                              @case ('changedDate') {
                                <span>
                                  {{
                                    'audit_trail.shift.changedDate.start'
                                      | translate
                                  }}
                                  <strong>{{
                                    auditTrailItem | auditTrailPreviousStartDate
                                  }}</strong>
                                  {{
                                    'audit_trail.shift.changedDate.center'
                                      | translate
                                  }}
                                  <strong>{{
                                    auditTrailItem.historyDelta.startDate
                                      | localizedDateFormat
                                  }}</strong>
                                </span>
                              }
                              @case ('changedName') {
                                <span>
                                  {{
                                    'audit_trail.shift.changedName.start'
                                      | translate
                                  }}
                                  <strong>{{
                                    auditTrailItem | auditTrailPreviousShiftName
                                  }}</strong>
                                  {{
                                    'audit_trail.shift.changedName.center'
                                      | translate
                                  }}
                                  <strong>{{
                                    auditTrailItem.historyDelta.name
                                  }}</strong>
                                </span>
                              }
                            }
                          </li>
                        }
                      }
                    </ul>
                  }

                  <span
                    nz-typography
                    class="audit-timeline-item__timestamp"
                    nzType="secondary"
                  >
                    {{ auditTrailItem.timeStamp | localizedDateTimeFormat }}
                    {{ 'general.hour' | translate }}
                  </span>
                </div>
              </nz-timeline-item>
            }
          }
        </nz-timeline>
      } @else {
        <nz-skeleton [nzActive]="true"></nz-skeleton>
      }
    </wilson-nz-drawer-content>
  </ng-container>

  <ng-template #extraTemplate>
    <wilson-nz-drawer-header [drawerId]="drawerId"></wilson-nz-drawer-header>
  </ng-template>
</nz-drawer>
